// Handle sticky nav inside container (improved)
function initStickyNav(navSelector) {
  const $nav = $(navSelector);
  const $container = $(".news-detail__inner");
  const $content = $(".p-news-detail__content");
  const $win = $(window);

  // state
  let navTop = 0,
    navLeft = 0,
    navWidth = 0,
    navHeight = 0;
  let containerTop = 0,
    containerBottom = 0,
    containerPadding = 0;
  let navState = "static"; // "static" | "fixed" | "absolute"
  let ticking = false;
  const headerHeight = 130; // adjust if you have a fixed header

  function getContainerPadding() {
    const styles = getComputedStyle($container[0]);
    return parseInt(styles.paddingBottom || 0, 10) || 0;
  }

  function addPlaceholder() {
    $nav.next(".nav-placeholder").remove();
    $nav.after(
      `<div class="nav-placeholder" style="width:${navWidth}px; height:${navHeight}px"></div>`
    );
  }

  function removePlaceholder() {
    $nav.next(".nav-placeholder").remove();
  }

  // recalc positions/sizes — if there's a placeholder, use it
  function recalc() {
    containerTop = $container.offset().top;
    containerBottom = containerTop + $container.outerHeight();
    containerPadding = getContainerPadding();

    const $ph = $nav.next(".nav-placeholder");
    if ($ph.length) {
      navTop = $ph.offset().top;
      navLeft = Math.round($ph.offset().left);
      navWidth = Math.round($ph.outerWidth());
      navHeight = Math.round($ph.outerHeight());
    } else {
      navTop = $nav.offset().top;
      navLeft = Math.round($nav.offset().left);
      navWidth = Math.round($nav.outerWidth());
      navHeight = Math.round($nav.outerHeight());
    }
  }

  function setFixed() {
    $nav.removeClass("is-absolute").addClass("is-fixed").css({
      position: "fixed",
      top: headerHeight + "px",
      left: navLeft + "px",
      width: navWidth + "px",
      "z-index": 1000,
    });
    addPlaceholder();
    navState = "fixed";
  }

  function setAbsolute() {
    $nav.removeClass("is-fixed").addClass("is-absolute").css({
      position: "absolute",
      top: containerBottom - containerTop - navHeight - containerPadding + "px",
      left: "",
      width: navWidth + "px",
      zIndex: 1000,
    });
    addPlaceholder();
    navState = "absolute";
  }

  function resetSticky() {
    $nav.removeClass("is-fixed is-absolute").css({
      position: "",
      top: "",
      left: "",
      width: "",
      "z-index": "",
    });
    removePlaceholder();
    navState = "static";
  }

  function onScroll() {
    if (!isDesktop()) return;

    recalc();

    if (Math.round($content.height()) < navHeight) {
      if (navState !== "static") resetSticky();
      return;
    }

    const st = $win.scrollTop();

    if (st >= navTop - headerHeight) {
      const navBottom = st + headerHeight + navHeight;

      if (navBottom < containerBottom - containerPadding) {
        if (navState !== "fixed") {
          recalc();
          setFixed();
        } else {
          $nav.css({ left: navLeft + "px", width: navWidth + "px" });
          addPlaceholder();
        }
      } else {
        if (navState !== "absolute") {
          recalc();
          setAbsolute();
        } else {
          $nav.css({
            top: containerBottom - containerTop - navHeight - containerPadding + "px",
            width: navWidth + "px",
          });
          addPlaceholder();
        }
      }
    } else {
      if (navState !== "static") resetSticky();
    }
  }

  function onResize() {
    if (!isDesktop()) {
      resetSticky();
      return;
    }

    recalc();

    if (navState === "fixed") {
      $nav.css({ left: navLeft + "px", width: navWidth + "px" });
      addPlaceholder();
    } else if (navState === "absolute") {
      $nav.css({
        top: containerBottom - containerTop - navHeight - containerPadding + "px",
        width: navWidth + "px",
      });
      addPlaceholder();
    } else {
      removePlaceholder();
    }

    onScroll();
  }

  // optimized event binding
  $win.on("scroll", function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        onScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  $win.on("resize orientationchange", function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        onResize();
        ticking = false;
      });
      ticking = true;
    }
  });

  // init
  recalc();
  onScroll();
}

// Slider init
function initServiceSlider() {
  const slickOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    dots: false,
    arrows: false,
    infinite: true,
    initialSlide: 1,
    centerPadding: "20%",
  };

  function checkSlider() {
    $(".js-news-list").each(function () {
      const $slider = $(this);

      if (isMobile()) {
        if (!$slider.hasClass("slick-initialized")) {
          $slider.slick(slickOptions);
        }
      } else {
        if ($slider.hasClass("slick-initialized")) {
          $slider.slick("unslick");
        }
      }
    });
  }

  checkSlider();
  $(window).on("resize orientationchange", checkSlider);
}

// helper
function isDesktop() {
  return window.matchMedia("(min-width: 1025px)").matches;
}
function isMobile() {
  return window.matchMedia("(max-width: 1024px)").matches;
}

// init
$(function () {
  initServiceSlider();
  setTimeout(function () {
    initStickyNav(".js-nav-news-detail");
  }, 100);
});
